import appConfig from 'appConfig';
import {
  Button,
  CheckboxGroup,
  CheckboxInput,
  Skeleton,
} from 'components/common';
import { useTags } from 'lib/tag';

const TagsFilter = ({
  value,
  onChange,
  onClear,
  condensed,
}: {
  value: (string | number | undefined)[] | undefined;
  onChange: (newValue: string[]) => void;
  onClear?: () => void;
  condensed?: boolean;
}) => {
  const SIZE_PER_PAGE = 15;
  const { isLoading, tags } = useTags({
    page: 1,
    sizePerPage: SIZE_PER_PAGE,
  });

  if (isLoading) return <Skeleton />;

  const handleOnChange = (
    newValue: (string | number | undefined)[],
  ) => {
    onChange(newValue as string[]);
  };

  return (
    <div>
      {appConfig.featureToggle.clearAllProductFilters === 'true' && (
        <div
          className={`widget widget-clean ${
            condensed ? 'tw-m-0 tw-p-0' : ''
          }`}
        >
          <label>Filters:</label>
          <Button
            variant="link"
            className="sidebar-filter-clear"
            onClick={() => onClear?.()}
          >
            <>Reset</>
          </Button>
        </div>
      )}
      <CheckboxGroup
        name="tag_ids"
        // @ts-ignore
        value={[].concat(value || [])}
        onChange={handleOnChange}
      >
        {tags.map((tag) => (
          <div className="filter-item">
            {/* @ts-ignore */}
            <CheckboxInput
              label={tag.name}
              value={tag.id}
              formCheckProps={{
                className: condensed ? 'tw-m-0' : '',
              }}
            />
          </div>
        ))}
      </CheckboxGroup>
    </div>
  );
};

export default TagsFilter;
